import Blog from '../../containers/blog';

export default Blog;
